<template>
  <div>
    <div class="main-title">账户管理</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add">新增账户</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索账户名称"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              style="width:180px"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="收支日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.state"
              @change="search(searchParams)"
              style="width:120px">
              <el-option label="全部状态" :value="null"></el-option>
              <el-option label="启用" value="1"></el-option>
              <el-option label="停用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.account_type"
              @change="search(searchParams)"
              style="width:120px">
              <el-option label="全部类型" :value="null"></el-option>
              <el-option label="现金" value="现金"></el-option>
              <el-option label="微信" value="微信"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="银行" value="银行"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="account_type"
          label="账户类型"
          width="90">
        </el-table-column>
        <el-table-column
          prop="name"
          label="账户名称"
          width="140">
        </el-table-column>
        <el-table-column
          prop="order_no"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="total_in_money"
          label="累计收入"
          width="110">
        </el-table-column>
        <el-table-column
          prop="total_out_money"
          label="累计支出"
          width="110">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="结余"
          width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" v-if="scope.row.status === '启用'" @click="invalid(scope.row)" style="color:#f56c6c;">停用</el-button>
            <el-button type="text" v-else @click="valid(scope.row)">启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增收支项目 -->
    <el-dialog :title="addForm.id > 0 ? '修改账户' : '新增账户'" :visible.sync="addFormVisible">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="120px">
        <el-form-item label="账户类型">
          <el-select v-model="addForm.account_type">
            <el-option label="现金账户" value="现金"></el-option>
            <el-option label="微信账户" value="微信"></el-option>
            <el-option label="支付宝账户" value="支付宝"></el-option>
            <el-option label="银行账户" value="银行"></el-option>
            <el-option label="其他账户" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="序号" prop="order_no">
          <el-input v-model.number="addForm.order_no"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
        <el-button @click="addFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NP from 'number-precision'
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'fin_account_list',
      pageSize: 0,
      searchForm: {
        query: '',
        state: '1',
        account_type: null,
        daterange: [
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
          new Date()
        ]
      },
      addForm: {
        id: 0,
        name: '',
        account_type: '现金',
        order_no: 0
      },
      addFormRules: {
        name: [
          { required: true, message: '请输入账户名称', trigger: 'blur' }
        ],
        order_no: [
          { required: true, message: '请输入序号', trigger: 'blur' }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          state: this.searchForm.state,
          account_type: this.searchForm.account_type,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.state === '0') {
        return 'row-red'
      } else {
        return ''
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'total_in_money' || column.property === 'total_out_money' || column.property === 'balance') {
          sums[index] = values.reduce((prev, curr) => {
            return NP.plus(prev, curr)
          }, 0)
        } else if (column.property === 'name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    add () {
      this.addForm = {
        id: 0,
        name: '',
        account_type: '现金',
        order_no: 0
      }
      this.addFormVisible = true
    },
    edit (row) {
      this.addForm = {
        id: row.id,
        name: row.name,
        account_type: row.account_type,
        order_no: row.order_no
      }
      this.addFormVisible = true
    },
    addFormCommit () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addFormCommiting = true
          let url = '/dbapi/fin_account_insert'
          if (this.addForm.id > 0) {
            url = '/dbapi/fin_account_update'
          }
          this.$http.post(url, this.addForm).then(response => {
            this.addFormCommiting = false
            if (response.data.success) {
              this.$refs.addForm.resetFields()
              this.addFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '保存成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    invalid (row) {
      this.$confirm('确定要停用这个账户吗？', '提示', {
        confirmButtonText: '确定停用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/fin_account_del', {
          id: row.id,
          state: '0'
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    valid (row) {
      this.$confirm('确定要启用这个账户吗？', '提示', {
        confirmButtonText: '确定启用',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/fin_account_del', {
          id: row.id,
          state: '1'
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/finance/Account.vue